/* Copyright (c) 2021 Caring Transitions Online Auctions. All Rights Reserved. */

// library imports
import { Buffer } from 'buffer';

import { Component } from 'react';
import { Form, Spinner } from 'react-bootstrap';
import { Link } from 'react-router-dom';

import { Validators } from "../../../shared/utils/Validators";
import { login } from '../../../shared/settings/auth';
import { APP_LOGO_PATH } from '../../../shared/settings/config';
import { SignInTextInput } from '../../../shared/form/FormInput';

import { getApi, postApi } from '../../../shared/services/apiHelper';
import { loginUser, userDetail } from '../../../shared/settings/apiConfig';
import { SparkleIcon } from '../../../shared/icons/Icons';

import 'bootstrap/dist/css/bootstrap.min.css';
import './SignIn.scss';
import '../NoAuth.scss';
import store from '../../../redux/store';
import { actions } from '../../../redux/actions';

class Signin extends Component {

    constructor(props) {
        super(props);

        this.state = {
            formValid: false,
            formControls: {
                email: { value: '', valid: false, error: '', validators: [Validators.required(), Validators.email()] },
                password: { value: '', valid: false, error: '', validators: [Validators.required()] }
            },
            formLoading: false,
            pwdtype: "password"
        }
    }

    saveValue = (type, event) => {
        this.setState({
            formControls: {
                ...this.state.formControls,
                [type]: {
                    ...this.state.formControls[type],
                    value: event.target.value
                },
            }
        })
    }

    onSignin = () => {
        this.setState({
            formLoading: true
        })
        const payload = {
            "email": this.state.formControls.email.value,
            "password": this.state.formControls.password.value
            // "password": Buffer.from(this.state.formControls.password.value, 'utf-8').toString('base64') (After that change password with this line)
        };
        postApi(loginUser, payload, false).then(async response => {
            this.setState({
                formLoading: false
            })
            // Pass user data to login function so it can be cached in localStorage
            login(response.data, response.data.user);
            store.dispatch(actions.setUser(response.data.user));

            this.props.history.push('/home');
        }).catch(error => {
            this.setState({
                formLoading: false,
                error:   `Sorry, we couldn't find an account with that email and password combination. Please try again or select the Forgot Password link.`
            });
        });
    }

    onInputChange = (controlName, event) => {
        this.setState({
            formControls: {
                ...this.state.formControls,
                [controlName]: Validators.validateFormControl(this.state.formControls[controlName], event.target.value)
            }
        }, () => {
            this.setState({
                formValid: Validators.validateForm(this.state.formControls)
            });
        })
    }

    render() {
        return (
            <div className="signin w-100" >
                <div className='scontainer'>
                    <div className='sigincontent'>
                        <div className='d-flex align-items-center'>
                            <img className="loader-img" src={APP_LOGO_PATH} alt="Logo" />
                        </div>
                        <div class="shadow-lg">
                            <div className='d-flex align-items-center flex-column gap-2'>
                                <div className='summary-icon-purple p-3 rounded'><SparkleIcon color="#FFF" /></div>
                                <span className='welcome-text text-2l font-weight-bold'>Welcome Back</span>
                                <span className='signin-text text-muted text-l'>
                                    Enter your credentials to access your account
                                </span>
                            </div>
                            <Form className="w-100 d-flex flex-column justify-content-center my-1 mt-2">
                                <SignInTextInput type={'text'} name={'email'} label={'Email'} placeholder={'Email'}
                                    value={this.state.formControls.email.value} error={this.state.formControls.email.error} onChange={(event) => { this.onInputChange('email', event); }} />
                                <SignInTextInput type={this.state.pwdtype} name={'password'} label={'Password'} placeholder={'Password'}
                                    value={this.state.formControls.password.value} error={this.state.formControls.password.error} onChange={(event) => { this.onInputChange('password', event); }}
                                    setType={(d) => {
                                        this.setState({
                                            pwdtype: d
                                        })
                                    }} />
                                <div className="rowcont justify-content-between my-1">
                                    <Form.Check type="checkbox" id="signin-checkbox" label="Keep me signed in" />
                                    <div className="d-flex align-items-center">
                                        <Link className='d-flex' to="/forgot-password" >
                                            <small className='text-n'>Forgot Password?</small>
                                        </Link>
                                    </div>
                                </div>
                                <div className='mt-3 text-center  text-m' >
                                    {this.state.error ? <span className='text-danger '>{this.state.error}</span> : ''}
                                </div>
                                <div type="button" className="btn btn-solid-orange fw-bold" onClick={this.onSignin} disabled={!this.state.formValid}>Sign In {this.state.formLoading ? <Spinner className='ms-2' as="span" animation="border" role="status" aria-hidden="true" /> : ''}</div>
                                <p className="py-2 text-center">New user? <Link to="/sign-up" ><span className='text-primary' style={{fontWeight:"bolder"}}> Register here</span></Link></p>
                            </Form>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default Signin;